interface IMockedPermitType {
  description: string
  isActive: boolean
  id: number
}

export const mockedPermitTypes: IMockedPermitType[] = [
  {
    description: 'Cold Work',
    isActive: true,
    id: 22,
  },
  {
    description: 'Entry',
    isActive: true,
    id: 23,
  },
  {
    description: 'Hot Tap',
    isActive: true,
    id: 24,
  },
  {
    description: 'Hot Work',
    isActive: true,
    id: 25,
  },
  {
    description: 'No Permit Needed - For Information',
    isActive: true,
    id: 26,
  },
  {
    description: 'Non-Flame',
    isActive: true,
    id: 27,
  },
]
